// GENERATED FILE — do not edit. Run `node scripts/generate-skin-contracts.mjs` instead.
// Derived from web/skins/<id>/skin.css; tests/contract/skinContracts.test.ts fails when this file and
// those stylesheets disagree.

/** The first frame of every built-in skin, for the case where the instance catalogue cannot answer —
 *  a daemon that is down or too old to serve one. A custom skin's paint travels in the catalogue, because
 *  only the daemon can read the file. */
export const BUILTIN_SKIN_PAINT: Readonly<Record<string, { background: string; colorScheme: 'light' | 'dark' }>> = {
  'studio-light': { background: '#ffffff', colorScheme: 'light' },
  'studio-oled': { background: '#000000', colorScheme: 'dark' },
  'umber-night': { background: '#131211', colorScheme: 'dark' },
  'studio-graphite': { background: '#0e0e0e', colorScheme: 'dark' },
};
